import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const TestCredentials = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const credentials = [
    { role: 'Member', email: 'member@gymflow.com', password: 'Member@123', icon: 'User', color: 'bg-blue-500' },
    { role: 'Trainer', email: 'trainer@gymflow.com', password: 'Trainer@123', icon: 'Dumbbell', color: 'bg-green-500' },
    { role: 'Staff', email: 'staff@gymflow.com', password: 'Staff@123', icon: 'Briefcase', color: 'bg-purple-500' },
    { role: 'Manager', email: 'manager@gymflow.com', password: 'Manager@123', icon: 'UserCog', color: 'bg-orange-500' },
    { role: 'Owner', email: 'owner@gymflow.com', password: 'Owner@123', icon: 'Crown', color: 'bg-red-500' },
    { role: 'SysAdmin', email: 'support@morethantechnologyllc.com', password: 'J@maica08*', icon: 'Shield', color: 'bg-gray-800' },
  ];

  const handleCopyCredentials = (email, password) => {
    const text = `Email: ${email}\nPassword: ${password}`;
    navigator.clipboard?.writeText(text);
  };

  return (
    <div className="w-full">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 rounded-lg bg-accent/10 border border-accent/20 hover:bg-accent/15 transition-colors duration-250 focus-ring"
      >
        <div className="flex items-center gap-3">
          <Icon name="Key" size={20} color="var(--color-accent)" />
          <span className="text-sm font-medium text-foreground">Test Credentials</span>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          color="var(--color-muted-foreground)"
        />
      </button>
      {isExpanded && (
        <div className="mt-4 space-y-3 animate-slideDown">
          {credentials?.map((cred, index) => (
            <div
              key={index}
              className="p-4 rounded-lg bg-card border border-border"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground mb-2">{cred?.role}</div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-muted-foreground w-16">Email:</span>
                      <span className="text-xs text-foreground font-mono">{cred?.email}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-muted-foreground w-16">Password:</span>
                      <span className="text-xs text-foreground font-mono">{cred?.password}</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => handleCopyCredentials(cred?.email, cred?.password)}
                  className="flex-shrink-0 p-2 rounded-lg hover:bg-muted transition-colors duration-250 focus-ring"
                  aria-label="Copy credentials"
                >
                  <Icon name="Copy" size={16} color="var(--color-muted-foreground)" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TestCredentials;